import BaseMap from 'components/BaseMap/BaseMap';
import { EARTHQUAKES_DEFAULT_ZOOM } from '../../config/earthquakes.config';
import EarthquakeMapLayers from './components/EarthquakeMapLayers/EarthquakeMapLayers';

const EarthquakeMapContent = ({
  earthquakes = [],
  selectedEarthquake = null,
  fallbackCenter,
  onSelectEarthquake,
  scrollZoom = true,
}) => {
  const mapCenter = selectedEarthquake?.position ?? fallbackCenter;

  return (
    <div className="position-relative d-flex flex-fill h-100 w-100 min-h-0 overflow-hidden rounded-2">
      <BaseMap
        mapCenter={mapCenter}
        zoom={EARTHQUAKES_DEFAULT_ZOOM}
        preserveLocationZoom
        scrollZoom={scrollZoom}
      >
        <EarthquakeMapLayers
          earthquakes={earthquakes}
          selectedEarthquakeId={selectedEarthquake?.id}
          onSelectEarthquake={onSelectEarthquake}
        />
      </BaseMap>
    </div>
  );
};

export default EarthquakeMapContent;
